// components/admin/content-management/sections/add/divider-add-section.component.jsx

import { useEffect, useState } from 'react';
import {
  Container,
  Label,
  Select,
  Option,
  Input
} from './divider-add-section.styles.jsx';

const styleOptions = [
  { value: 'solid', label: 'Solid' },
  { value: 'dashed', label: 'Dashed' },
  { value: 'dotted', label: 'Dotted' },
  { value: 'double', label: 'Double' }
];

const thicknessOptions = [
  { value: '1px', label: 'Thin (1px)' },
  { value: '2px', label: 'Medium (2px)' },
  { value: '4px', label: 'Thick (4px)' },
  { value: '8px', label: 'Extra Thick (8px)' }
];

const colorOptions = [
  { value: '#000000', label: 'Black' },
  { value: '#ffffff', label: 'White' },
  { value: '#cccccc', label: 'Gray' }
];

const marginOptions = [
  { value: '1rem', label: 'Small (1rem)' },
  { value: '2rem', label: 'Medium (2rem)' },
  { value: '4rem', label: 'Large (4rem)' }
];

const DividerAddSection = ({ onChange = () => {} }) => {
  const [style, setStyle] = useState('solid');
  const [thickness, setThickness] = useState('1px');
  const [color, setColor] = useState('#000000');
  const [margin, setMargin] = useState('2rem');
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      onChange({ content: {}, metadata: { style, thickness, color, margin } });
      setInitialized(true);
    }
  }, [initialized]);

  useEffect(() => {
    if (initialized) {
      onChange({ content: {}, metadata: { style, thickness, color, margin } });
    }
  }, [style, thickness, color, margin]);

  return (
    <Container>
      <Label htmlFor="divider-style">Divider Style</Label>
      <Select id="divider-style" value={style} onChange={(e) => setStyle(e.target.value)}>
        {styleOptions.map((option) => (
          <Option key={option.value} value={option.value}>{option.label}</Option>
        ))}
      </Select>

      <Label htmlFor="divider-thickness">Thickness</Label>
      <Select id="divider-thickness" value={thickness} onChange={(e) => setThickness(e.target.value)}>
        {thicknessOptions.map((option) => (
          <Option key={option.value} value={option.value}>{option.label}</Option>
        ))}
      </Select>

      <Label htmlFor="divider-color">Color</Label>
      <Select id="divider-color" value={color} onChange={(e) => setColor(e.target.value)}>
        {colorOptions.map((option) => (
          <Option key={option.value} value={option.value}>{option.label}</Option>
        ))}
      </Select>

      <Label htmlFor="divider-margin">Top/Bottom Margin</Label>
      <Select id="divider-margin" value={margin} onChange={(e) => setMargin(e.target.value)}>
        {marginOptions.map((option) => (
          <Option key={option.value} value={option.value}>{option.label}</Option>
        ))}
      </Select>
    </Container>
  );
};

export default DividerAddSection;